<mat-card class="logon_card">
  <mat-card-content>
    <form #PasswordResetForm="ngForm" (ngSubmit)="onSubmit()">
      <h2>Password neu setzen</h2>
      <div>
        <p>Neues Password mit Bestätigung eingeben</p>
      </div>
      <br />
      @if (!loginValid) {
        <mat-error>
          Das neue Password fehlt.
        </mat-error>
      }
      <mat-form-field class="fill_width">
        <mat-label>Neues Password</mat-label>
        <input matInput type="password" [(ngModel)]="newPassword" name="newpassord" required>
        <mat-error>
          Bitte neues Passwort eingeben.
        </mat-error>
      </mat-form-field>
      <mat-form-field class="fill_width">
        <mat-label>Neues Password bestätigen</mat-label>
        <input matInput type="password" [(ngModel)]="newPasswordConfirm" name="newpasswordconfirm" required>
        <mat-error>
          Bitte neues Passwort bestätigen.
        </mat-error>
      </mat-form-field>
      <button mat-raised-button color="primary" [disabled]="!PasswordResetForm.form.valid">Übernehmen</button>
    </form>
  </mat-card-content>
</mat-card>